export default __webpack_public_path__ + "static/media/newspaper.7a0c61c4.svg";